// ABOUTME: The v28 forgiven sky behind 5C: the sky-forgiven gradient down to the horizon and a 26px sun upper right.
// ABOUTME: Anchored to the viewport over OceanScene's shared sea, which supplies the horizon line and the ground.

import { Box } from '@mui/material';
import OceanScene from '../../crossing/OceanScene';
import { useHorizon } from '../../crossing/useHorizon';
import { useShellBottom } from '../../crossing/useShellBottom';
import { useCrossingReducedMotion } from '../../crossing/useReducedMotion';
import { sunPlacement } from './sunPlacement';
import { SCENE_IN } from '../clouds/weatherVignetteKeyframes';
import { CROSSING_SKY_FORGIVEN_BOTTOM, CROSSING_SKY_FORGIVEN_TOP, CROSSING_SUN_FILL, CROSSING_SUN_GLOW } from '../../../../theme/crossingTokens';

const SUN_SIZE = 26;

export default function ForgivenSkyScene() {
  const reducedMotion = useCrossingReducedMotion();
  const { line, phone } = useHorizon();
  const shellBottom = useShellBottom();
  const { centreY, centreXPercent } = sunPlacement({ shellBottom, line, phone });
  return (
    <>
      <OceanScene sky="none" />
      <Box aria-hidden sx={{ position: 'fixed', inset: 0, overflow: 'hidden', zIndex: -1 }}>
        <Box
          data-testid="sky-scene-forgiven"
          sx={{ position: 'absolute', left: 0, right: 0, top: 0, height: line, background: `linear-gradient(${CROSSING_SKY_FORGIVEN_TOP}, ${CROSSING_SKY_FORGIVEN_BOTTOM})`,
            opacity: reducedMotion ? 1 : 0, animation: reducedMotion ? undefined : `${SCENE_IN} 0.8s ease forwards` }}
        />
      </Box>
      <Box
        aria-hidden
        data-testid="sky-scene-sun"
        sx={{
          position: 'fixed', zIndex: -1, top: centreY - SUN_SIZE / 2, left: `calc(${centreXPercent}% - ${SUN_SIZE / 2}px)`, width: SUN_SIZE, height: SUN_SIZE,
          borderRadius: '50%', backgroundColor: CROSSING_SUN_FILL, boxShadow: CROSSING_SUN_GLOW,
        }}
      />
    </>
  );
}
